<pbc-sorter [config]="KundenSorterConfig" [sorter]="kunden.sorter$ | async" (sorterChange)="kunden.sorter$.next($event)"></pbc-sorter>
